import React from "react";

const CrossSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="27.236"
      height="29"
      viewBox="0 0 27.236 29"
    >
      <path
        fill="#ff3636"
        d="M18.781 94.5l7.743-8.244a2.712 2.712 0 000-3.665L24.8 80.759a2.331 2.331 0 00-3.442 0L13.618 89l-7.743-8.241a2.331 2.331 0 00-3.442 0l-1.72 1.832a2.712 2.712 0 000 3.665L8.456 94.5l-7.743 8.244a2.712 2.712 0 000 3.665l1.721 1.832a2.331 2.331 0 003.442 0L13.618 100l7.743 8.244a2.331 2.331 0 003.442 0l1.721-1.832a2.712 2.712 0 000-3.665z"
        transform="translate(0 -80)"
      ></path>
    </svg>
  );
};

export default CrossSVG;
